import { render, staticRenderFns } from "./OwnerList.vue?vue&type=template&id=02df20c2&scoped=true&lang=html&"
import script from "./OwnerList.vue?vue&type=script&lang=js&"
export * from "./OwnerList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02df20c2",
  null
  
)

export default component.exports